module.exports = __webpack_public_path__ + "static/media/expanding_red.4375e04e.png";